import { useEffect, useRef } from 'react'
import type { AssistantMessage } from '../types/assistant'
import { AssistantMessageBubble } from './assistant-message-bubble'

interface Props {
  messages: AssistantMessage[]
  agentInitials: string
  agentColor: string
}

export function AssistantMessageList({ messages, agentInitials, agentColor }: Props) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-3 min-h-0 bg-muted/20">
      {messages.map((msg) => (
        <AssistantMessageBubble
          key={msg.id}
          message={msg}
          agentInitials={agentInitials}
          agentColor={agentColor}
        />
      ))}
      <div ref={bottomRef} />
    </div>
  )
}
